module.exports = __webpack_public_path__ + "static/media/photogrid.1b2df55b.png";